/* src/app/pages/amplify-auth/user-forgot-password/user-forgot-password.component.scss */
.mat-mdc-form-field {
  --mat-mdc-form-field-floating-label-scale: 0.75;
  display: block;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}
/*# sourceMappingURL=user-forgot-password.component.css.map */
